<h1 matDialogTitle>Export with or without National Application Annexes (NAAs)</h1>
<div mat-dialog-content [innerHTML]="message"></div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" (click)="exportHas(false)">Export Without NAAs</button>
  <button mat-button mat-raised-button color="basic" (click)="exportHas(true)">Export With NAAs</button>
</div>
